interface Props {
  isDark: boolean;
}

function BrandLogo({ isDark }: Props) {
  return <div>{isDark ? <DarkThemeLogo/> : <LightThemeLogo/>}</div>;
}

export default BrandLogo;

function LightThemeLogo() {
  return (
    <>
      {/*?xml version="1.0" encoding="UTF-8"?*/}
      <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        viewBox="0 0 3840 2160"
        width={150}
      >
        {/* Generator: Adobe Illustrator 29.8.6, SVG Export Plug-In . SVG Version: 2.1.1 Build 1)  */}
        <defs>
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n      .st0 {\n        fill: #111;\n      }\n\n      .st1 {\n        fill: none;\n        stroke-width: 10px;\n      }\n\n      .st1, .st2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .st3 {\n        fill: url(#linear-gradient);\n      }\n\n      .st4, .st2 {\n        fill: #fff;\n      }\n    ",
            }}
          />
          <linearGradient
            id="linear-gradient"
            x1="1709.1"
            y1="1732.2"
            x2="2202.4"
            y2="1318.2"
            gradientTransform="translate(0 2616.1) scale(1 -1)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#d4a84a" />
            <stop offset=".4" stopColor="#bf913e" />
            <stop offset=".5" stopColor="#b8893a" />
            <stop offset={1} stopColor="#8c6526" />
          </linearGradient>
        </defs>
        <g>
          <path d="M284.1,1481.4c2.7,0,5.4.3,8.1.3h985.4v23.6c.4-.5.3-.3,0,0-.2,0-.4.4-.5.4-336.8,0-673.7.2-1010.5.3-1.3,0-2.6,0-4.3-.2v-837.2h3313.8c1.4,4.5,1.9,825,.5,837.1h-861.9c0-6.5-.1-12.9,0-19.4,0-2.9,2-4.4,5-4.4h832.7c1.4-5.6,2.1-778.9.7-789.2-5.8-.4-11.8-1.2-17.8-1.2-35.8,0-71.7,0-107.5,0H282.7v777.4c0,3.9.2,7.7.3,11.5.4.4.8.8,1.1,1.2h0Z" />
          <path d="M429.7,898.5c.9-.2,1.8-.5,2.6-.5,20.4,0,40.8,0,61.2.3.9,0,1.7,0,3.1.3v338.5h180c1,17.3.2,34.1.7,51.3-3,0-5.2.4-7.4.4h-234.7c-1.8,0-3.6-.2-5.4-.3-.4-.4-.8-.7-1.1-1,0-4.3-.3-8.6-.3-12.8v-368.9c0-1.8.1-3.6.2-5.4.4-.5.8-1.1,1.2-1.7v-.2Z" />
          <path d="M2894.4,1287.8v-127.7c0-7.7,2.3-14.6,5.4-21.5,4.4-9.9,8.3-20,12.4-30,1.2-2.8,2.5-5.5,3.7-8.4,3.7-8.6,7.4-17.3,11.1-25.9,2.6-6.1,5.2-12.3,7.7-18.4,3.9-9.6,7.7-19.3,11.6-28.9,1.3-3.2,3-6.3,4.3-9.5,4-9.6,7.9-19.2,12-28.8,1.9-4.4,3.8-8.9,5.6-13.3,4-9.5,7.9-19,11.9-28.6,2-4.9,4.2-9.6,6.3-14.5,2.9-6.9,5.8-13.9,8.6-20.9,1.7-4.1,3.3-8.2,5.2-12.9h77.5c1.4,4.3.4,7.9-1.5,11.7-15,29.9-29.8,59.8-44.8,89.7-15.1,30.2-30.3,60.5-45.4,90.7-5.5,11.1-11,22.2-16.8,33.2-2,3.7-3,7.5-3,11.7-.7,29.2-1.5,58.3-2.1,87.5-.5,19.9-.8,39.8-1.2,59.7,0,5-.8,6-5.1,6-20.4,0-40.8,0-61.2,0-.5,0-.9-.4-2.1-.9h0Z" />
          <path d="M1026.2,1291.6h-35.5c-4,0-5.9-2.9-6.9-5.5-2.8-7.9-4.6-16.1-7-24.1-2.1-6.9-4.7-13.8-6.8-20.7-3-10.1-5.4-20.3-8.6-30.3-3.4-10.7-7.3-21.2-10.8-31.7-1.3-3.7-2.1-7.6-3.3-11.4-3-9.7-5.8-19.5-8.9-29.1-2.6-8-5-16-7.2-24.2-2.9-10.6-6.8-20.8-10-31.3-4.3-13.9-8.4-27.9-12.7-41.9-.6-2.1-1.8-4-2.4-6.1-1.6-5.4-3-10.9-4.7-16.3-4.3-13.8-8.8-27.6-13.1-41.4-3.5-11.2-6.6-22.5-10.1-33.6-3.6-11.5-7.6-22.9-11.1-34.5-1-3.3-.6-7-1-11.1h78.6c3.5,13.5,6.9,26.6,10.4,39.7,5.4,19.9,10.8,39.7,16.3,59.6,3.2,11.8,6.9,23.4,9.6,35.3,2.6,11.2,5.7,22.1,9.4,32.9,3,8.5,4,17.7,6.3,26.4,3.4,12.7,7.4,25.2,10.8,37.8,2,7.7,3,15.7,5.1,23.4,2.4,8.9,5.4,17.6,8.1,26.4,1.6,5.3,3.3,10.5,4.6,15.8.8,3.5,1.4,7.1,1.4,10.7v82.8c0,.5-.3.9-.6,2.3h0Z" />
          <path d="M730.9,895.3h67.1c1.5,5.5,2.2,376.8.9,392.3-4.5,1.4-55.9,1.9-68.1.6v-392.9h0Z" />
          <path d="M1124.8,898.4h77.3c1.7,5.7,0,10.6-1.7,15.4-3.8,11.3-8.2,22.5-12,33.9-4.2,12.5-7.5,25.3-12,37.8-3,8.2-5.6,16.5-7.9,25-1.4,5.1-2.6,10.4-4.3,15.4-2.7,8-6,15.9-8.7,24-3.2,9.7-5.7,19.6-9,29.3-6.6,19.8-13.7,39.4-20.2,59.2-2.1,6.4-3.2,13.3-5.2,19.7-2.5,7.9-5.5,15.6-8.1,23.5-3.9,12.1-7.5,24.4-11.5,36.5-4.7,14.2-9.8,28.3-14.5,42.6-2.1,6.3-3.5,12.8-5.4,19.1-1.2,3.9-3,7.7-4.5,11.6h-33.4c0-1.6-.4-3.4-.4-5v-97.1c0-7.5,2.4-14.3,4.5-21.3,3.6-12.3,7.2-24.8,10.7-37.2,1.8-6.4,3.6-12.9,5.3-19.4,3.8-13.8,7.4-27.8,11.3-41.6,2.6-9,5.8-17.8,8.5-26.7,3.1-10.6,5.9-21.2,9-31.8,4.4-15.3,8.8-30.6,13.2-45.8,2.5-8.6,4.9-17.2,7.4-25.8,3.9-13.4,7.8-26.8,11.9-41.2h-.3Z" />
          <path d="M1337.4,1288.5h-66.2v-392.4c4.8-1.4,54.5-1.9,67.7-.6.2,3.4.5,6.9.5,10.4,0,105.2,0,210.4,0,315.6v61.8c0,1.4-.3,2.7-.4,4-.5.4-1,.8-1.5,1.2Z" />
          <path d="M2541.5,1288.4h-67c-1.5-4.9-1.8-383.7-.4-393.1h67.3v393.1h0Z" />
          <path d="M3220.4,895.3v392.9h-67.2v-392.9h67.2Z" />
          <path d="M2781.9,898.9c3.3-.3,6.4-.9,9.6-.9,21.3,0,42.6,0,63.9.3,6.3,0,6.7-1,9.4,6.9,2.5,7.3,5.9,14.3,8.7,21.4,3.8,9.6,7.4,19.2,11.2,28.9,4.2,10.8,8.4,21.6,12.5,32.4,6.9,18,14.1,36,20.4,54.2,2.2,6.3,2.1,13.2-.8,19.8-4.6,10.4-8.8,21-13.1,31.6-3.8,9.1-7.5,18.2-11.2,27.2-6.1,2-7.1.7-9.3-3.7-3.9-8-7.4-16.3-11.2-24.4-4.5-9.6-9.2-19.1-13.7-28.7-4.3-9.4-8.3-18.8-12.7-28.1-4.3-9-8.9-17.8-13.3-26.7-1.6-3.3-3-6.8-4.6-10.1-5.9-12.6-11.8-25.2-17.5-37.9-2.5-5.6-4.8-11.3-7.4-16.9-3.6-7.8-7.4-15.5-11.1-23.2-3.3-6.9-6.6-13.7-9.9-20.5,0,0,0-.4.2-1.5h0Z" />
          <path d="M2720.1,1288.4c-2.3,0-4.5.3-6.8.3h-154.6v-50.8h162.5v49.3c-.4.4-.7.8-1.1,1.2h0Z" />
          <path d="M2720.1,949c-1.6,0-3.1.3-4.7.3h-150.9c-1.8,0-3.5,0-5.8-.2v-49.5c5.9-1.8,144.1-2.7,162.6-1v49.2c-.4.4-.8.8-1.2,1.2h0Z" />
          <path d="M1359.4,1287.3v-47.5c.2,0,.5-.2.5-.3,0-.4,0-.7-.2-1,1.7-.3,3.4-.9,5.1-.9h149.4c49.8,0,2.6.2,4.8.4,0,16.6.7,33-.4,49.4-.5.4-1,.8-1.5,1.2-9,0-18.1,0-27.1,0h-118.6c-39.5,0-7.2-.2-10.8-.3-.5-.3-.8-.7-1.2-1.1h0Z" />
          <path d="M1518.8,898.5v50.3h-159.4v-50.1c2.5-.2,5.1-.7,7.7-.7h148.8c.7,0,1.3.2,2.9.5Z" />
          <path d="M3241.5,1288.2v-50.4h159.3c.6,16.7,0,33.3.4,50.4h-159.8.1Z" />
          <path d="M3241.4,948.9v-50.4c53.2-.8,106.1,0,159.5-.5v50.9h-159.5Z" />
          <path d="M2558.7,1111.8v-43.5h146c0,14.4.2,28.7,0,43.5h-146Z" />
          <path d="M1359.3,1111.8v-43.2h142.3v43.2h-142.3Z" />
          <path d="M3241.4,1112v-43.4h142.2v43.4h-142.2Z" />
          <path d="M1687.5,1537.5c-17.4,2.5-17.5,2.4-25.7-12.8-3.5-6.4-7-12.7-10.4-19-3.8-7-9.5-9.9-18.3-8.7-.5,6.5,0,13.2-.2,19.8v20.7h-15.9v-97.9c1.9,0,3.6-.3,5.4-.3,10.7,0,21.3-.3,31.9,0,5.3.2,10.8,1.1,15.7,3,3.3,1.3,6.4,4.5,8.1,7.6,5.9,11.1,6,22.6,0,33.8-2.3,4.3-6.2,7.1-10.6,9.1-1.6.7-3.1,1.5-3.9,1.8,3.5,4.6,7.4,8.7,10.2,13.5,5,8.8,9.4,18,14,27.1-.2.6-.2,1.3-.3,2v.2ZM1633.2,1480.2c8.5,0,16.3.3,24.1,0,4.6-.3,7.4-4.2,8-9.4.8-6.3-1-10.1-5.6-12.3-8.6-4.1-17.5-1.6-26.6-2.2v24.1h0Z" />
          <path d="M2313.6,1480.2c-.1,16.3-.3,32.5-.4,48.8v8.6h-14.6v-98h15.7c10.1,20.2,20.2,40.6,30.3,61,.5.8,1,1.6,1.6,2.4v-63.1h14.9v98.2h-13.6c-2.4,0-3.4-1.5-4.4-3.5-7.5-15.4-15.1-30.8-22.7-46.1-1.4-2.8-3-5.5-4.5-8.3-.8-1.3-1.5-2.7-2.3-4-.5.2-1,.5-1.5.7.4,1.1.9,2.2,1.4,3.3h.1Z" />
          <path d="M1458.4,1467.5c-4.9.3-9.9.7-15.5,1-.7-2-1.6-3.9-2-6-1.2-6.1-6.2-7.3-11-8.2-5.4-1-12.4,1.9-14.4,5.5-1.3,2.2-.7,7.7,1.4,9.4,2.6,2.1,5.3,4.2,8.4,5.4,5.9,2.2,12.1,3.6,18,5.7,7.6,2.7,13.4,7.4,15.3,15.7,1.1,4.7,2.9,9.5,2.5,14.2-1.1,18.4-10.9,29.1-29.8,29.6-10.1.3-19.4-1.4-26.2-9.5-2.1-2.5-3.9-5.5-5.1-8.6-1.9-4.9-3.1-10-4.9-15.5,5.9-.9,10.9-1.6,15.5-2.2,2,4.2,3.5,8.1,5.6,11.6,4.2,7,11,8.3,19.2,5.9,6.4-1.9,8.1-6.4,8.9-11.8.6-4.9-2.4-8.7-7.5-10.4-5.6-1.9-11.3-3.8-17-5.6-8.8-2.7-14.8-8.4-19-16.3-.5-.9-.6-2-.7-3.1-.2-3.8-.6-7.7-.5-11.5.5-14.2,9.9-24.2,24.2-24.8,5.7-.3,11.7.2,17.3,1.7,7.1,1.8,12.2,6.8,14.5,13.9,1.4,4.4,3.6,8.6,2.6,13.9h.2Z" />
          <path d="M1892.7,1440.7c.2,4.7.4,9.4.7,15.1-7.3.8-14.4,0-21.5.3-7.2,0-14.4,0-21.8,0v21.4c12.8,1.3,25.8.2,39.3.8v16.3h-39v26.5h43.8v16.5h-60.3v-98.2h57.5c.5.4.9.8,1.4,1.2h0Z" />
          <path d="M2578.6,1455.9h-41.3v22.2c6.3,0,12.8.2,19.3.2h20.1v16.3h-39.4v26.8h43.6v16.4h-59.4c-.1-1.3-.4-2.6-.4-3.9v-89.6c0-1.1.2-2.2.3-3.4.5-.4.9-.7,1.3-1.1h55.8c.4.4.8.8,1.2,1.2v13.6c-.5.4-.9,1-1.3,1.5l.2-.2Z" />
          <path d="M2213.6,1439.5h17c10.6,32.3,21.3,64.8,32.1,97.4-5.1,2.4-10.4,1.2-15.4,1-1.1,0-2.7-1.7-3.1-2.9-2.1-6.4-3.9-12.8-6-19.4h-31.8c-2.2,6.9-4.5,14-7,21.8h-17.1c10.5-32.7,20.8-64.9,31.4-97.9h0ZM2223.2,1466.4h-2c-3.4,10.4-6.4,20.9-9.2,31.8h20.3c-3.1-11-6.1-21.5-9-31.9h-.1Z" />
          <path d="M1521.2,1440.7c0,21.5-.2,42.9.4,64.4.3,10.5,6.7,18.8,18.5,17.3,6.3-.8,10.4-4.6,11.1-10.9.6-5.8,1.2-11.6,1.3-17.4.2-15.6,0-31.2,0-46.8v-7.7h16.2c0,1.8.2,3.4.2,4.9,0,21.2,0,42.5-.4,63.7,0,5.7-1.3,11.6-3.4,16.9-4,9.8-12.8,13.6-22.7,14.4-5.8.5-11.7-.6-17.6-1.1-1,0-2-.8-2.9-1.3-9.8-5.4-15.4-13.6-15.7-24.9-.5-23.7-.8-47.4-1.1-71.2,0-.4.4-.8.8-1.5h13.9c.5.3,1,.7,1.4,1.1h0Z" />
          <path d="M2460.7,1471.1c-2.5-4.4-3.7-7.8-5.9-10.5-5-6.2-14.3-7.2-20.7-2.6-5,3.6-8.5,8.5-9.2,14.5-1,8.5-.7,17.1-1.3,25.6-.5,6.5,2.3,11.8,5.8,16.8,2,2.9,4.8,5.7,7.9,7.1,5.9,2.6,13.3-.3,17.3-5.8,1.5-2.2,2.8-4.7,3.9-7.1,1-2.2,1.6-4.6,2.6-7.4,4.7,2,9.2,4,13.8,5.9,2.2,9.3-9.2,27.3-18.1,29.4-4.5,1.1-9.1,2.2-13.7,2.7-10.4,1.2-18.2-3.8-24.5-11.3-6.6-7.9-10.6-17.3-11.2-27.7-.5-8.5-.5-17.2,0-25.7.8-15.6,12.9-31.8,26.7-35.9,9.9-3,19.5-2,28.5,3.9,7.4,5,10,12.8,12.8,20.5.4,1-.9,3.4-1.9,3.7-4.3,1.6-8.8,2.7-12.5,3.8h-.3Z" />
          <path d="M1737.4,1439.7c6.5,22.7,13.1,45.6,19.8,69.1,9.2-22.7,12.1-46.6,20.5-69.2h16.5c-8.8,33.2-18.6,65.6-28.3,98.2h-17.5c-9.5-32.6-19-65.1-28.6-98.1h17.6Z" />
          <path d="M2017.6,1521.6h39.4v16.1h-55.3v-97h16v80.9h0Z" />
          <path d="M2109.1,1520.7c10.2.2,20.3.4,30.6.5h7.1c1.3,5.4.9,10.7.6,16.4h-55.6c-.1-1.9-.3-3.3-.3-4.8v-90.9c.4-.5.8-1,1.1-1.5h13.7c.4.5.8,1,1.2,1.5,0,23.1,0,46.2.1,69.3,0,2.7.2,5.4.3,8.1.3.5.7,1,1.1,1.4h0Z" />
          <path d="M1939.2,1439.7h15.1v97.7h-15.1v-97.7Z" />
          <path d="M2313.6,1480.2c-.5-1.1-1-2.2-1.5-3.3.5-.2,1-.5,1.5-.7.8,1.3,1.5,2.7,2.3,4h-2.3Z" />
          <path d="M2346.2,1500.5v2.4c-.5-.8-1-1.6-1.6-2.4h1.7,0Z" />
          <path d="M1521.2,1440.7c-.5-.4-1-.8-1.4-1.2.5.4,1,.8,1.4,1.2Z" />
          <path d="M1892.7,1440.7c-.5-.4-.9-.8-1.4-1.2.5.4.9.8,1.4,1.2Z" />
          <path d="M1517.1,1288.5c.5-.4,1-.8,1.5-1.2-.5.4-1,.8-1.5,1.2Z" />
          <path d="M2522.9,1439.7c-.5.4-.9.7-1.3,1.1.5-.4.9-.7,1.3-1.1Z" />
          <path d="M1359.4,1287.3c.4.4.8.8,1.2,1.1-.4-.4-.8-.8-1.2-1.1Z" />
          <path d="M2579.8,1440.7c-.4-.4-.8-.8-1.2-1.2.4.4.8.8,1.2,1.2Z" />
          <path d="M1337.4,1288.5c.5-.4,1-.8,1.5-1.2-.5.4-1,.8-1.5,1.2Z" />
          <path d="M2720.1,1288.4c.4-.4.8-.8,1.1-1.1-.4.4-.7.8-1.1,1.1Z" />
          <path d="M2578.6,1455.9c.4-.5.8-1,1.2-1.5-.4.5-.8,1-1.2,1.5Z" />
          <path d="M2720.1,949c.4-.4.8-.9,1.2-1.3-.4.4-.8.9-1.2,1.3Z" />
          <path d="M428.6,1287.3c.4.4.8.7,1.1,1-.4-.4-.8-.7-1.1-1Z" />
          <path d="M1359.7,1238.4c0,.4.2.7.2,1s-.3.2-.5.3c0-.5.2-.9.3-1.4h0Z" />
          <path
            className="st0"
            d="M284.1,1481.4c-.4-.4-.7-.8-1.1-1.2.4.4.8.8,1.1,1.2Z"
          />
          <path d="M429.7,898.5c-.4.5-.8,1.1-1.2,1.7.4-.5.8-1.1,1.2-1.7Z" />
          <path d="M2115.9,1520.9c-.4-.5-.8-.9-1.1-1.4.4.5.8.9,1.1,1.4Z" />
          <path d="M1687.5,1537.5c0-.7,0-1.4,0-2,0,.6,0,1.3,0,2Z" />
          <rect
            className="st3"
            x="1696.7"
            y="903.6"
            width="528.2"
            height={383}
          />
          <g>
            <rect
              className="st1"
              x="1779.5"
              y="968.1"
              width="248.3"
              height="248.3"
            />
            <circle className="st1" cx="1903.6" cy="1092.2" r="113.9" />
            <circle className="st4" cx="1837.1" cy={1037} r="23.4" />
            <circle className="st4" cx="1868.1" cy={1068} r="7.6" />
            <path
              className="st2"
              d="M1903.6,1193.1c36.5-14.1,72.9-35.6,90.1-72,2.9-4.9,4.4-10.7,6.9-15.8-.2,2.9-.5,5.8-1,8.8-6.6,45.3-52.4,76.3-96.1,79.1h0Z"
            />
          </g>
          <polygon
            className="st4"
            points="2026.9 1063.6 2152.6 979.2 2148.1 1210.9 2028.7 1122.2 2026.9 1063.6"
          />
        </g>
      </svg>
    </>
  );
}

function DarkThemeLogo() {
  return (
    <>
      {/*?xml version="1.0" encoding="UTF-8"?*/}
      <svg
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        viewBox="0 0 3840 2160"
        width={150}
      >
        {/* Generator: Adobe Illustrator 29.8.6, SVG Export Plug-In . SVG Version: 2.1.1 Build 1)  */}
        <defs>
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n      .st0 {\n        fill: #111;\n      }\n\n      .st1 {\n        fill: none;\n        stroke-width: 10px;\n      }\n\n      .st1, .st2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .st3 {\n        fill: url(#linear-gradient);\n      }\n\n      .st4 {\n        fill: #e5e5e5;\n      }\n\n      .st5, .st2 {\n        fill: #fff;\n      }\n\n      .st6 {\n        fill: #c8c8c8;\n      }\n    ",
            }}
          />
          <linearGradient
            id="linear-gradient"
            x1="1718.8"
            y1="886.6"
            x2="2189.3"
            y2="1281.3"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#ebcb7e" />
            <stop offset=".3" stopColor="#d6b469" />
            <stop offset=".5" stopColor="#c9a55c" />
            <stop offset={1} stopColor="#9c7b38" />
          </linearGradient>
        </defs>
        <g>
          <path
            className="st5"
            d="M359.7,1456.5c2.6.1,5.2.3,7.8.3h939.8v22.5c.4-.4.3-.3,0-.1-.2.1-.3.4-.5.4-321.2,0-642.5.2-963.7.3-1.3,0-2.5-.1-4.1-.2v-798.5h3160.6c1.3,4.3,1.8,786.9.5,798.4h-822.1c0-6.2-.1-12.3,0-18.5,0-2.8,1.9-4.2,4.8-4.2h794.2c1.3-5.4,2-742.9.6-752.7-5.5-.4-11.3-1.2-16.9-1.2-34.2-.1-68.4,0-102.5,0H358.4v7.6c0,71.9,0,143.8,0,215.7v518.2c0,3.7.2,7.3.3,11,.4.3.7.7,1.1,1.1Z"
          />
          <path
            className="st5"
            d="M498.6,900.5c.8-.2,1.7-.4,2.5-.4,19.4,0,38.9.1,58.4.3.8,0,1.6.1,2.9.3v322.9h171.6c1,16.5.2,32.5.7,48.9-2.9.1-5,.3-7.1.3-74.6,0-149.2,0-223.8,0-1.7,0-3.4-.2-5.2-.3-.3-.3-.7-.7-1.1-1,0-4.1-.3-8.2-.3-12.3,0-117.3,0-234.5,0-351.8,0-1.7.1-3.4.2-5.2.3-.5.7-1.1,1.1-1.6Z"
          />
          <path
            className="st5"
            d="M2849.4,1271.8v-12.4c0-36.5,0-73,0-109.4,0-7.4,2.2-13.9,5.1-20.5,4.2-9.4,7.9-19.1,11.9-28.6,1.1-2.7,2.3-5.3,3.5-8,3.6-8.2,7.1-16.5,10.6-24.7,2.5-5.8,4.9-11.7,7.3-17.6,3.7-9.2,7.3-18.4,11-27.5,1.3-3.1,2.9-6,4.1-9,3.9-9.1,7.6-18.3,11.4-27.5,1.8-4.2,3.6-8.4,5.4-12.6,3.8-9.1,7.6-18.1,11.4-27.2,1.9-4.6,4-9.2,6-13.8,2.8-6.6,5.5-13.3,8.2-20,1.6-3.9,3.1-7.8,4.9-12.3h74c1.3,4.1.4,7.5-1.4,11.2-14.3,28.5-28.4,57-42.7,85.6-14.4,28.8-28.9,57.7-43.3,86.5-5.3,10.6-10.5,21.2-16,31.7-1.9,3.6-2.8,7.1-2.9,11.1-.6,27.8-1.4,55.6-2,83.5-.4,19-.7,38-1.1,57,0,4.8-.7,5.7-4.9,5.7-19.4,0-38.9,0-58.4-.1-.5,0-.9-.3-2-.8Z"
          />
          <path
            className="st5"
            d="M1067.5,1275.4c-11.4,0-22.6,0-33.8,0-3.8,0-5.7-2.8-6.5-5.3-2.6-7.5-4.4-15.3-6.7-23-2-6.6-4.5-13.2-6.5-19.8-2.9-9.6-5.2-19.4-8.2-28.9-3.2-10.2-6.9-20.2-10.3-30.3-1.2-3.6-2-7.3-3.1-10.9-2.8-9.3-5.5-18.6-8.5-27.8-2.5-7.6-4.8-15.3-6.8-23-2.7-10.1-6.5-19.9-9.6-29.8-4.1-13.2-8-26.6-12.1-39.9-.6-2-1.7-3.9-2.3-5.8-1.6-5.2-2.9-10.3-4.5-15.5-4.1-13.2-8.4-26.3-12.5-39.5-3.3-10.7-6.3-21.4-9.6-32.1-3.4-11-7.3-21.9-10.6-32.9-1-3.2-.6-6.7-.9-10.6h74.9c3.3,12.9,6.5,25.4,9.9,37.9,5.1,19,10.3,37.9,15.5,56.8,3.1,11.2,6.5,22.3,9.1,33.6,2.5,10.7,5.4,21,9,31.4,2.8,8.1,3.8,16.8,6,25.2,3.2,12.1,7.1,24,10.3,36.1,1.9,7.4,2.9,15,4.9,22.3,2.3,8.5,5.2,16.8,7.8,25.2,1.5,5,3.1,10,4.4,15.1.8,3.3,1.3,6.8,1.3,10.2,0,26.3,0,52.7,0,79,0,.5-.3.9-.6,2.2Z"
          />
          <path
            className="st5"
            d="M785.9,897.5h64c1.4,5.3,2.1,359.4.9,374.1-4.3,1.3-53.3,1.8-64.9.6v-374.7Z"
          />
          <path
            className="st5"
            d="M1161.6,900.4h73.7c1.6,5.4,0,10.1-1.6,14.7-3.6,10.8-7.8,21.5-11.4,32.3-4,12-7.2,24.2-11.4,36-2.8,7.8-5.3,15.8-7.5,23.8-1.3,4.9-2.5,9.9-4.1,14.7-2.6,7.7-5.8,15.2-8.3,22.9-3,9.3-5.5,18.7-8.6,28-6.3,18.9-13,37.6-19.3,56.5-2,6.1-3,12.6-5,18.8-2.3,7.5-5.3,14.9-7.8,22.4-3.8,11.6-7.2,23.3-11,34.9-4.5,13.6-9.3,27-13.8,40.6-2,6-3.3,12.2-5.2,18.2-1.2,3.8-2.8,7.4-4.3,11.1h-31.8c-.1-1.6-.4-3.2-.4-4.8,0-30.9,0-61.7,0-92.6,0-7.1,2.3-13.6,4.3-20.3,3.5-11.8,6.8-23.6,10.2-35.5,1.7-6.1,3.4-12.3,5.1-18.5,3.6-13.2,7-26.5,10.8-39.7,2.5-8.6,5.5-17,8.1-25.5,3-10.1,5.7-20.2,8.6-30.4,4.2-14.6,8.4-29.1,12.6-43.7,2.3-8.2,4.7-16.4,7.1-24.6,3.7-12.8,7.4-25.6,11.3-39.3Z"
          />
          <path
            className="st5"
            d="M1364.4,1272.5h-63.2v-374.3c4.5-1.3,52-1.8,64.6-.6.2,3.2.5,6.5.5,9.9,0,100.4,0,200.7-.1,301.1v58.9c0,1.3-.3,2.6-.4,3.9-.5.3-1,.7-1.4,1.1Z"
          />
          <path
            className="st5"
            d="M2512.7,1272.5h-63.9c-1.4-4.7-1.7-366-.3-375h64.2v375Z"
          />
          <path className="st5" d="M3160.3,897.5v374.7h-64.1v-374.7h64.1Z" />
          <path
            className="st5"
            d="M2742.1,900.9c3.2-.3,6.1-.8,9.1-.8,20.3,0,40.7,0,61,.3,6,0,6.4-1,9,6.6,2.3,7,5.6,13.6,8.3,20.4,3.6,9.2,7.1,18.4,10.7,27.6,4,10.3,8,20.6,11.9,30.9,6.6,17.2,13.4,34.3,19.5,51.7,2.1,6,2,12.6-.7,18.9-4.4,9.9-8.4,20-12.5,30.1-3.6,8.7-7.2,17.4-10.7,26-5.8,1.9-6.8.6-8.9-3.6-3.8-7.7-7-15.5-10.7-23.3-4.3-9.1-8.8-18.2-13-27.4-4.1-8.9-7.9-18-12.1-26.8-4.1-8.6-8.5-17-12.7-25.5-1.6-3.2-2.9-6.5-4.4-9.7-5.6-12-11.2-24-16.7-36.1-2.4-5.3-4.6-10.8-7.1-16.1-3.4-7.4-7.1-14.8-10.6-22.2-3.2-6.5-6.3-13-9.5-19.6,0-.1,0-.4.2-1.4Z"
          />
          <path
            className="st5"
            d="M2683.1,1272.4c-2.2,0-4.3.3-6.5.3-47.5,0-95,0-142.6,0h-4.9v-48.4h155v47.1c-.3.4-.7.8-1.1,1.1Z"
          />
          <path
            className="st5"
            d="M2683.1,948.7c-1.5,0-3,.3-4.5.3h-144c-1.7,0-3.4-.1-5.5-.2v-47.2c5.6-1.7,137.4-2.6,155.1-1v46.9c-.3.3-.7.8-1.1,1.2Z"
          />
          <path
            className="st5"
            d="M1385.3,1271.3c0-15.1,0-30.2,0-45.3.2,0,.5-.2.5-.3,0-.3-.1-.6-.2-1,1.6-.3,3.2-.9,4.9-.9,47.5,0,95,0,142.5,0s2.5.2,4.5.3c.1,15.8.6,31.5-.4,47.2-.5.4-1,.8-1.4,1.2-8.6,0-17.2.1-25.8.1-37.7,0-75.4,0-113.1,0s-6.9-.2-10.3-.3c-.4-.3-.8-.7-1.2-1Z"
          />
          <path
            className="st5"
            d="M1537.4,900.6v47.9h-152v-47.8c2.4-.2,4.9-.6,7.4-.6,47.3,0,94.6,0,141.9,0,.6,0,1.3.2,2.7.4Z"
          />
          <path
            className="st5"
            d="M3180.4,1272.2v-48.1h152c.6,15.9,0,31.8.4,48.1h-152.4Z"
          />
          <path
            className="st5"
            d="M3180.3,948.6v-48.1c50.7-.8,101.2-.1,152.1-.5v48.6h-152.1Z"
          />
          <path
            className="st5"
            d="M2529.2,1104v-41.5h139.3c0,13.8.2,27.4,0,41.5h-139.2Z"
          />
          <path className="st5" d="M1385.2,1104v-41.2h135.7v41.2h-135.7Z" />
          <path className="st5" d="M3180.3,1104.2v-41.4h135.6v41.4h-135.6Z" />
          <path
            className="st5"
            d="M1698.3,1510c-16.6,2.4-16.7,2.3-24.5-12.2-3.3-6.1-6.7-12.1-9.9-18.1-3.6-6.7-9.1-9.4-17.4-8.3-.4,6.2-.1,12.6-.2,18.9,0,6.5,0,12.9,0,19.8h-15.2v-93.4c1.8,0,3.5-.3,5.1-.3,10.2,0,20.3-.3,30.4.1,5,.2,10.3,1,14.9,2.9,3.1,1.2,6.1,4.3,7.8,7.3,5.6,10.6,5.7,21.6,0,32.3-2.2,4.1-5.9,6.8-10.1,8.7-1.5.7-3,1.4-3.7,1.7,3.4,4.4,7.1,8.3,9.7,12.9,4.8,8.4,8.9,17.2,13.3,25.8-.2.6-.2,1.3-.3,1.9ZM1646.5,1455.4c8.1,0,15.6.3,23-.1,4.4-.3,7.1-4,7.7-9,.7-6-1-9.6-5.3-11.7-8.2-3.9-16.7-1.5-25.4-2.1,0,8,0,15.2,0,22.9Z"
          />
          <path
            className="st5"
            d="M2295.4,1455.3c-.1,15.5-.3,31-.4,46.5v8.2h-13.9v-93.5h14.9c9.6,19.3,19.3,38.7,28.9,58.1.5.8,1,1.6,1.5,2.3,0-.8,0-1.5,0-2.3v-57.8h14.2v93.7h-13c-2.3,0-3.2-1.4-4.2-3.3-7.1-14.7-14.4-29.4-21.6-44-1.3-2.7-2.9-5.3-4.3-7.9-.7-1.3-1.5-2.6-2.2-3.8-.5.2-.9.5-1.4.7.4,1,.9,2.1,1.3,3.1Z"
          />
          <path
            className="st5"
            d="M1479.8,1443.3c-4.7.3-9.4.6-14.8,1-.6-1.9-1.5-3.8-1.9-5.7-1.1-5.8-5.9-6.9-10.5-7.8-5.2-1-11.8,1.8-13.7,5.3-1.2,2.1-.7,7.3,1.3,8.9,2.5,2,5.1,4,8,5.1,5.6,2.1,11.5,3.4,17.2,5.5,7.2,2.6,12.8,7.1,14.6,15,1,4.5,2.7,9.1,2.4,13.6-1,17.5-10.4,27.8-28.4,28.3-9.7.3-18.5-1.3-25-9-2-2.4-3.7-5.2-4.8-8.2-1.8-4.6-3-9.5-4.6-14.8,5.7-.8,10.4-1.5,14.8-2.1,1.9,4,3.3,7.8,5.3,11.1,4,6.7,10.5,7.9,18.4,5.6,6.1-1.8,7.8-6.1,8.4-11.3.6-4.6-2.3-8.3-7.1-9.9-5.4-1.8-10.7-3.6-16.2-5.3-8.4-2.6-14.2-8-18.1-15.5-.5-.9-.6-1.9-.6-2.9-.2-3.6-.6-7.3-.4-11,.5-13.6,9.5-23,23.1-23.7,5.5-.3,11.2.2,16.5,1.6,6.8,1.7,11.6,6.5,13.9,13.3,1.3,4.2,3.5,8.2,2.5,13.2Z"
          />
          <path
            className="st5"
            d="M1894,1417.7c.2,4.5.4,9,.6,14.4-6.9.7-13.7.1-20.5.3-6.8.1-13.7,0-20.8.1v20.4c12.2,1.2,24.6.2,37.5.7v15.5h-37.2v25.3h41.8v15.8h-57.5v-93.7h54.9c.4.4.9.8,1.3,1.2Z"
          />
          <path
            className="st5"
            d="M2548.2,1432.1h-39.4v21.1c6,0,12.2.2,18.4.2,6.2,0,12.5,0,19.2,0v15.5h-37.6v25.5h41.6v15.6h-56.6c-.1-1.3-.4-2.5-.4-3.7,0-28.5,0-57,0-85.5,0-1.1.2-2.1.3-3.2.4-.3.8-.7,1.3-1,17.8,0,35.5,0,53.2,0,.4.4.7.7,1.1,1.1,0,4.3,0,8.6,0,12.9-.4.4-.8.9-1.2,1.4Z"
          />
          <path
            className="st5"
            d="M2200,1416.6h16.2c10.1,30.8,20.3,61.8,30.6,92.9-4.9,2.3-9.9,1.1-14.7.9-1,0-2.6-1.6-2.9-2.7-2-6.1-3.8-12.2-5.7-18.5h-30.4c-2.1,6.6-4.3,13.3-6.7,20.8h-16.3c10-31.2,19.9-61.9,29.9-93.4ZM2209.2,1442.2c-.6,0-1.3,0-1.9,0-3.2,9.9-6.1,20-8.8,30.4h19.4c-3-10.5-5.8-20.5-8.6-30.4Z"
          />
          <path
            className="st5"
            d="M1539.6,1417.7c0,20.5-.2,41,.3,61.4.3,10,6.4,17.9,17.6,16.5,6-.8,9.9-4.4,10.6-10.3.6-5.5,1.2-11,1.2-16.6.2-14.9,0-29.7,0-44.6v-7.3h15.5c0,1.7.2,3.2.2,4.7,0,20.3,0,40.5-.4,60.8-.1,5.4-1.3,11.1-3.2,16.1-3.8,9.4-12.2,13-21.6,13.7-5.5.4-11.2-.6-16.8-1-1,0-1.9-.7-2.8-1.2-9.3-5.2-14.7-13-14.9-23.8-.5-22.6-.7-45.2-1.1-67.9,0-.3.3-.7.7-1.5h13.2c.4.3.9.7,1.3,1.1Z"
          />
          <path
            className="st5"
            d="M2435.7,1446.7c-2.3-4.2-3.6-7.4-5.6-10-4.8-5.9-13.6-6.9-19.8-2.5-4.8,3.4-8.1,8.1-8.8,13.8-.9,8.1-.7,16.3-1.3,24.4-.4,6.2,2.2,11.3,5.5,16,1.9,2.7,4.5,5.5,7.5,6.8,5.6,2.5,12.7-.3,16.5-5.5,1.5-2.1,2.6-4.5,3.7-6.8,1-2.1,1.6-4.4,2.5-7.1,4.5,1.9,8.8,3.8,13.2,5.7,2.1,8.9-8.7,26-17.3,28.1-4.3,1-8.7,2.1-13,2.6-9.9,1.1-17.4-3.6-23.4-10.7-6.3-7.6-10.1-16.5-10.7-26.4-.5-8.1-.4-16.4,0-24.5.8-14.9,12.3-30.3,25.5-34.2,9.5-2.8,18.6-1.9,27.1,3.8,7.1,4.8,9.5,12.2,12.2,19.6.3.9-.9,3.2-1.8,3.6-4.1,1.6-8.4,2.6-12,3.6Z"
          />
          <path
            className="st5"
            d="M1745.8,1416.7c6.2,21.6,12.5,43.5,18.9,65.9,8.7-21.6,11.6-44.5,19.5-66h15.8c-8.4,31.7-17.7,62.5-27,93.7h-16.7c-9-31.1-18.1-62.1-27.3-93.6,5.6,0,11,0,16.8,0Z"
          />
          <path
            className="st5"
            d="M2013.1,1494.8h37.6v15.4h-52.8v-92.5h15.2c0,25.6,0,51,0,77.1Z"
          />
          <path
            className="st5"
            d="M2100.4,1494c9.7.2,19.4.3,29.1.5,2.1,0,4.3,0,6.8,0,1.3,5.2.8,10.2.6,15.6h-53c-.1-1.8-.3-3.2-.3-4.6,0-28.9,0-57.8,0-86.7.3-.5.7-1,1.1-1.5,4.4,0,8.7,0,13.1,0,.4.5.7,1,1.1,1.4,0,22,0,44,.1,66.1,0,2.6.2,5.2.3,7.8.3.4.7.9,1,1.3Z"
          />
          <path className="st5" d="M1938.3,1416.7h14.4v93.2h-14.4v-93.2Z" />
          <path d="M2295.4,1455.3c-.5-1-.9-2.1-1.4-3.2.5-.2.9-.5,1.4-.7.7,1.3,1.5,2.6,2.2,3.8-.8,0-1.5,0-2.2,0Z" />
          <path d="M2326.5,1474.7c0,.8,0,1.5,0,2.3-.5-.8-1-1.6-1.5-2.3h1.6Z" />
          <path
            className="st6"
            d="M1539.6,1417.7c-.4-.4-.9-.7-1.3-1.1.4.3.9.7,1.3,1.1Z"
          />
          <path
            className="st4"
            d="M1894,1417.7c-.4-.4-.9-.8-1.3-1.2.4.4.9.8,1.3,1.2Z"
          />
          <path
            className="st4"
            d="M1535.7,1272.5c.5-.4,1-.8,1.4-1.2-.5.3-1,.7-1.4,1.2Z"
          />
          <path
            className="st4"
            d="M2495,1416.7c-.4.3-.8.7-1.3,1,.4-.3.8-.7,1.3-1Z"
          />
          <path d="M1385.3,1271.3c.4.3.8.7,1.1,1.1-.4-.3-.7-.7-1.1-1.1Z" />
          <path
            className="st4"
            d="M2549.3,1417.7c-.4-.4-.7-.7-1.1-1.1.3.4.7.7,1.1,1.1Z"
          />
          <path d="M1364.4,1272.5c.5-.4,1-.8,1.4-1.1-.5.3-1,.7-1.4,1.1Z" />
          <path d="M2683.1,1272.4c.3-.3.7-.7,1.1-1.1-.3.3-.7.7-1.1,1.1Z" />
          <path
            className="st4"
            d="M2548.2,1432.1c.4-.5.7-1,1.1-1.5-.3.5-.7,1-1.1,1.5Z"
          />
          <path
            className="st5"
            d="M2683.1,948.7c.4-.4.7-.8,1.1-1.2-.3.4-.7.8-1.1,1.2Z"
          />
          <path d="M497.6,1271.3c.3.3.7.7,1.1,1-.3-.3-.7-.6-1.1-1Z" />
          <path
            className="st5"
            d="M1385.6,1224.7c0,.3.2.6.2,1s-.3.2-.5.3c0-.4.2-.9.3-1.3Z"
          />
          <path
            className="st0"
            d="M359.7,1456.5c-.3-.4-.7-.8-1.1-1.2.4.4.7.8,1.1,1.2Z"
          />
          <path
            className="st5"
            d="M498.6,900.5c-.4.5-.7,1.1-1.1,1.6.3-.5.7-1.1,1.1-1.6Z"
          />
          <path
            className="st5"
            d="M2106.8,1494.1c-.3-.4-.7-.9-1.1-1.3.3.4.7.9,1.1,1.3Z"
          />
          <path
            className="st5"
            d="M1698.3,1510c0-.6,0-1.3.1-1.9,0,.6,0,1.3-.1,1.9Z"
          />
          <rect
            className="st3"
            x={1707}
            y="905.4"
            width="503.8"
            height="365.3"
          />
          <g>
            <rect
              className="st1"
              x={1786}
              y="966.9"
              width="236.8"
              height="236.8"
            />
            <circle className="st1" cx="1904.4" cy="1085.3" r="108.7" />
            <circle className="st5" cx={1841} cy="1032.7" r="22.3" />
            <circle className="st5" cx="1870.5" cy="1062.2" r="7.3" />
            <path
              className="st2"
              d="M1904.4,1181.5c34.8-13.4,69.5-34,85.9-68.7,2.7-4.7,4.2-10.2,6.6-15.1-.2,2.8-.5,5.5-.9,8.4-6.3,43.2-50,72.8-91.6,75.4h0Z"
            />
          </g>
          <polygon
            className="st5"
            points="2022 1058 2141.9 977.6 2137.6 1198.5 2023.7 1113.9 2022 1058"
          />
        </g>
      </svg>
    </>
  );
}
